import { getConfig } from "@jti/fe-common";
export const getLocationByIpUrl = () => getConfig().GET_LOCATION_BY_IP_URL || "https://des-get-ip.jtides.com/";
export const getAddressByIp = () => fetch(getLocationByIpUrl()).then((response) => response.json());
//# sourceMappingURL=getAddressByIp.js.map